import { expandCompositeComponent } from "@doenet/doenetml-worker-javascript";
async function resolvePathImmediatelyToNodeIdx(name, rustCore, jsCore, origin = 0) {
  if (!jsCore.core) {
    return -1;
  }
  const initialMatch = name.match(/^([\w-]+)((\[\d+\])*)/);
  if (!initialMatch) {
    throw Error(`Invalid name to resolve: ${name}`);
  }
  const path = [
    {
      type: "flatPathPart",
      name: initialMatch[1],
      index: extractIndex(initialMatch[2])
    }
  ];
  let nameLeft = name.slice(initialMatch[0].length);
  while (nameLeft.length > 0) {
    const nextMatch = nameLeft.match(/^\.([\w-]+)((\[\d+\])*)/);
    if (!nextMatch) {
      throw Error(`Invalid name to resolve: ${name}`);
    }
    path.push({
      type: "flatPathPart",
      name: nextMatch[1],
      index: extractIndex(nextMatch[2])
    });
    nameLeft = nameLeft.slice(nextMatch[0].length);
  }
  try {
    let resolution = rustCore.resolve_path({ path }, origin, false);
    while (resolution.unresolvedPath !== null) {
      if (resolution.unresolvedPath[0].name !== "") {
        return -1;
      }
      const refComponent = jsCore.core._components[resolution.nodeIdx];
      const haveComposite = jsCore.core.componentInfoObjects.isCompositeComponent({
        componentType: refComponent.componentType,
        includeNonStandard: true
      });
      if (!haveComposite || refComponent.isExpanded) {
        return -1;
      }
      const index = resolution.unresolvedPath[0].index;
      if (index.length === 0) {
        throw Error(
          "Something went wrong as we have a ref resolution without a name or an index"
        );
      }
      const replacementIdx = index[0].value[0];
      if (typeof replacementIdx !== "string") {
        throw Error(
          "Not implemented: we have not implemented `resolvePathImmediatelyToNodeIdx` for paths that contain references to nodes."
        );
      }
      await refComponent.stateValues.readyToExpandWhenResolved;
      await expandCompositeComponent({
        core: jsCore.core,
        component: refComponent
      });
      resolution = rustCore.resolve_path({ path }, origin, false);
    }
    return resolution.nodeIdx;
  } catch (err) {
    console.error(err);
    return -1;
  }
}
function extractIndex(s) {
  const index = [];
  for (const match of s.matchAll(/\[(\d+)\]/g)) {
    index.push({ value: [match[1]] });
  }
  return index;
}
export {
  resolvePathImmediatelyToNodeIdx
};
//# sourceMappingURL=index.js.map
